document.addEventListener("DOMContentLoaded", function () {
    console.log("section-article-header.js loaded")

    const $articleHeader = $("section.article-header")
    const $articleHeaderWrapper = $articleHeader.find(".wrapper")
    const $titleAndSlider = $articleHeaderWrapper.find(".title-and-slider")
    const $mainImageWrapper = $articleHeader.find(".main-image")
    const $thumbnailsWrapper = $articleHeader.find(".thumbnails")
    const $articleImageSlider = $articleHeader.find(".article-image-slider")

    const $articlesList = $articleHeader.find(".articles-list")
    const $blogs = $articlesList.find(".blog")
    const $articles = $articlesList.find(".articles")

    // console.log("$articleHeader", $articleHeader)
    // console.log("$mainImageWrapper", $mainImageWrapper)
    // console.log("$thumbnailsWrapper", $thumbnailsWrapper)
    // console.log("$articlesList", $articlesList)
    // console.log("$blogs", $blogs)
    // console.log("$articles", $articles)

    $mainImageWrapper.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: $thumbnailsWrapper.find(".slick-wrapper"),
        prevArrow: $articleImageSlider.find(".slick-prev"),
        nextArrow: $articleImageSlider.find(".slick-next"),
        infinite: false,
        adaptiveHeight: true,
    })

    $thumbnailsWrapper.find(".slick-wrapper").slick({
        variableWidth: true,
        asNavFor: $mainImageWrapper,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {},
            },
        ],
    })

    $mainImageWrapper.on("afterChange", function (event, slick, currentSlide) {
        updateWrapperMaxHeight()
    })

    $mainImageWrapper.on("lazyLoaded", function () {
        updateWrapperMaxHeight()
    })

    $mainImageWrapper.on("init", function (slick) {
        updateWrapperMaxHeight()
    })

    $blogs.on("click", function () {
        $blogs.removeClass("active")
        $(this).addClass("active")
        const currBlogHandle = $(this).data("blog-handle")

        console.log("currBlogHandle", currBlogHandle)

        $articles.each(function () {
            if ($(this).data("blog-handle") === currBlogHandle) {
                $(this).addClass("active")
            } else {
                $(this).removeClass("active")
            }
        })
    })

    function debounce(func, wait) {
        let timeout
        return function () {
            clearTimeout(timeout)
            timeout = setTimeout(func, wait)
        }
    }

    function isMobile() {
        return window.innerWidth < 1024
    }

    function onImageReady($wrapper, callback, delay = 200) {
      const img = $wrapper.find('img')[0];
      if (!img) {
        console.warn('No image found');
        return;
      }
    
      if (img.complete && img.naturalWidth > 0) {
        setTimeout(callback, delay);
      } else {
        img.onload = () => setTimeout(callback, delay);
        img.onerror = () => console.warn('Image failed to load');
      }
    }

    function updateWrapperMaxHeight() {
        console.log("updateWrapperMaxHeight")

        if (isMobile()) {
            $articleHeaderWrapper.css("maxHeight", "unset")
            return
        }

        $articleHeaderWrapper.animate({
            maxHeight: $titleAndSlider.outerHeight(),
        })
    }

    $(window).on("resize", debounce(updateWrapperMaxHeight, 300))

    // Trigger the resize event
    $(window).trigger("resize")

    onImageReady($mainImageWrapper, updateWrapperMaxHeight, 200);
  })
